module.exports = __webpack_public_path__ + "img/blimpy9.1eabcef4.jpg";